import UntrackedModel from "../../../common/models/untracked/untrackedModel";
import ExternalConnectionEnvironment from "./externalConnectionEnvironment";
import IRepo from '~/interfaces/repo'
import Repo from '~/state/modules/repo'
import EndPoint from '../../../formability/organization_settings/models/connections/endPoint'
import { RelationType } from '~/models/relationType'
import { Hash } from '~/interfaces/hashInterfaces'
import { ObjectHelper } from '~/helpers/objectHelper'
import { GenericType } from '~/interfaces/genericTypeInterfaces'
import { ModelType } from '~/enums/modelType'
import { IImposter, IImposterFactory, IImposterOptions } from '~/interfaces/imposterInterfaces'
import Imposter from '~/models/imposter'

export default class ExternalConnection extends UntrackedModel implements IImposterFactory {
  static repo: IRepo<ExternalConnection> = new Repo<ExternalConnection>('external_connections', ExternalConnection);

  name: string = '';
  live_environment: ExternalConnectionEnvironment = null;
  test_environment: ExternalConnectionEnvironment = null;
  end_points: Hash<EndPoint> = {}
  _type: string

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      'end_points': {type: EndPoint, relationType: RelationType.dictionary},
    };
  }

  createEmbeddedObject = {
    end_points(parent, json) {
      return EndPoint.repo.findOrCreate(json.client_id, json.id)
    }
  }

  endPointsArray(): EndPoint[] {
    return ObjectHelper.toArray(this.end_points)
  }

  static get displayName() {
    return 'External Connection'
  }

  get genericType(): GenericType {
    return ModelType.Object
  }

  get modelType(): ModelType {
    return ModelType.API
  }

  get model_type(): ModelType {
    return this.modelType;
  }

  imposterFor({ modelType, options }: { modelType: ModelType; options?: IImposterOptions }): IImposter {
    return new Imposter({
      ...ObjectHelper.sliceProperties(this as ExternalConnection, 'id', 'genericType', 'modelType'),
      isCollection: false,
    }, options);
  }
}